export const environment = {
  production: true,
  apiUrl: 'https://www.gloeckle.de/orbit-nkl/api/v2',
  configName: 'nklConfig',
  sentryUrl: 'https://455b1e962879418cac28b33323dbeb53@sentry.gloeckle-it.de/3'
};
